import React from 'react';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import { LINKEDIN_BUSINESS_PAGE } from '../../../config/constants';

const LinkedinBusinessPageBestTimeToPostTab: React.FC = () => {
  return (
    <BestTimeToPostTab platforms={[LINKEDIN_BUSINESS_PAGE]} />
  );
};

export default LinkedinBusinessPageBestTimeToPostTab;